import { TerritoryLevel } from "@mapmycustomers/shared";

import { RegionDemographicData } from "../store/layers/boundaries/types/BoundariesLayerData";

export const levelToRegion: Record<TerritoryLevel, keyof RegionDemographicData> = {
  [TerritoryLevel.ADM1]: "state",
  [TerritoryLevel.ADM2]: "fips",
  [TerritoryLevel.ADM3]: "zip",
};

const getLevelData = (data: RegionDemographicData, level: TerritoryLevel) =>
  data[levelToRegion[level]];

export default getLevelData;
